"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _auth = require("@/utils/auth");
var _DocumentCategory = require("@/lib/enum/DocumentCategory");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      acceptance_options: [{
        value: _DocumentCategory.DocumentCategory.Acceptance.FALSE.val,
        label: _DocumentCategory.DocumentCategory.Acceptance.FALSE.label
      }, {
        value: _DocumentCategory.DocumentCategory.Acceptance.TRUE.val,
        label: _DocumentCategory.DocumentCategory.Acceptance.TRUE.label
      }, {
        value: _DocumentCategory.DocumentCategory.Acceptance.CANCEL.val,
        label: _DocumentCategory.DocumentCategory.Acceptance.CANCEL.label
      }]
    };
  },
  computed: {
    searchTitle: {
      get: function get() {
        return this.$store.getters.searchClientInvoiceWord;
      },
      set: function set(val) {
        this.$store.dispatch('client/setInvoiceWord', val);
      }
    },
    searchAcceptance: {
      get: function get() {
        return this.$store.getters.searchClientInvoiceAcceptance;
      },
      set: function set(val) {
        this.$store.dispatch('client/setSearchInvoiceAcceptance', val);
      }
    }
  },
  methods: {
    searchInvoice: function () {
      var _searchInvoice = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              console.log('searchInvoice');
              _context.next = 1;
              return this.$store.dispatch('client/setPageTop', 0);
            case 1:
              _context.next = 2;
              return this.$store.dispatch('client/fetchClientsInvoice', (0, _auth.getClientID)());
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function searchInvoice() {
        return _searchInvoice.apply(this, arguments);
      }
      return searchInvoice;
    }()
  }
};